import {Component, NgZone, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {ToastrService} from "ngx-toastr";
import feather from "feather-icons";
import {StockService} from "../../../../../../services/stock/stock.service";

/** Ligne affichée : mapping GET /api/stock/entrepot/:entrepot_id */
export interface EtatStockRow {
    /** ID produit ERP (navigation détail) */
    id: number;
    ref_interne: string;
    nom: string;
    prix_unitaires: number;
    prixVente: number | null;
    quantity: number;
    /** quantité × prix d'achat */
    valeur_en_stock: number;
    /** alias filtres (quantité) */
    stock: number;
}

@Component({
    selector: 'app-etat-table',
    templateUrl: './etat-table.component.html',
    styleUrls: ['./etat-table.component.scss']
})
export class EtatTableComponent implements OnInit {
    currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
    userId = this.currentUser?.id;
    paginatedData : any [] =[];
    basicSelectedOption = 10;
    searchTerm: string = '';
    showFilter = false;
    filteredData : any [] =[];
    allData: any[] = [];
    filters = {
        label: '',
        valeur: '',
        valeurOperator: '=',
        prixAchat: '',
        prixAchatOperator: '=',
        prixVente: '',
        prixVenteOperator: '=',
        stock: ''
    };


    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private toastr: ToastrService,
        private stockService: StockService,
        private ngZone: NgZone
    ) {}

    pages: number[] = [];
    searchText = '';
    currentPage = 1;
    totalPages = 1;
    totalItems: number = 0;
    filterSummary: string = '';
    items: any[] = [];
    selectedWarehouseId: number;
    warehouseId: number;
    isLoading = false;

    ngOnInit(): void {
        this.route.queryParams.subscribe(params => {
            this.warehouseId = +params['entrepot_id'];
            if (this.warehouseId) {
                this.loadProductsForWarehouse();
            }
        });
    }
    toggleFilter() {
        this.showFilter = !this.showFilter;
        setTimeout(() => feather.replace(), 0);
    }
    resetFilters() {
        this.filters = {
            label: '',
            valeur: '',
            valeurOperator: '=',
            prixAchat: '',
            prixAchatOperator: '=',
            prixVente: '',
            prixVenteOperator: '=',
            stock: ''
        };
        this.searchTerm = '';
        this.currentPage = 1;
       // this.loadProductsForWarehouse();
    }

    clearFilter() {
        this.resetFilters();
        this.filterSummary = '';
        this.searchTerm = '';
         this.currentPage = 1;
        this.loadProductsForWarehouse();
    }
    onSearch() {
        this.currentPage = 1;
        this.applyFilters();
    }
    applyFilters() {
        this.currentPage = 1;
        this.updateFilterSummary();
       // this.updateFilteredData();
        this.showFilter = false;
        this.loadProductsForWarehouse();
    }
    updatePagination() {
        const pageSize = Number(this.basicSelectedOption) || 10;
        this.totalPages = Math.ceil(this.filteredData.length / pageSize) || 1;
        this.currentPage = Math.min(this.currentPage, this.totalPages);
        this.pages = Array.from({ length: this.totalPages }, (_, i) => i + 1);

        const start = (this.currentPage - 1) * pageSize;
        this.paginatedData = this.filteredData.slice(start, start + pageSize);
        setTimeout(() => {
            try {
                feather.replace();
            } catch {
                /* ignore */
            }
        }, 0);
    }

    updateFilterSummary() {
        const activeFilters: string[] = [];

        // Label filter
        if (this.filters.label && this.filters.label.trim() !== '') {
            activeFilters.push(`Label: "${this.filters.label.trim()}"`);
        }

        // Valeur en stock filter
        if (this.filters.valeur && this.filters.valeur !== '') {
            activeFilters.push(`Valeur: ${this.filters.valeurOperator} ${this.filters.valeur}`);
        }

        // Prix d'achat filter
        if (this.filters.prixAchat && this.filters.prixAchat !== '') {
            activeFilters.push(`Prix Achat: ${this.filters.prixAchatOperator} ${this.filters.prixAchat}`);
        }

        // Prix de vente filter
        if (this.filters.prixVente && this.filters.prixVente !== '') {
            activeFilters.push(`Prix Vente: ${this.filters.prixVenteOperator} ${this.filters.prixVente}`);
        }

        // Stock filter (exact value)
        if (this.filters.stock && this.filters.stock !== '') {
            activeFilters.push(`Stock: = ${this.filters.stock}`);
        }

        this.filterSummary = activeFilters.join(', ');
    }

    getActiveFilters(): Array<{key: string, label: string, value: any}> {
        const activeFilters: Array<{key: string, label: string, value: any}> = [];

        // Label filter
        if (this.filters.label && this.filters.label.trim() !== '') {
            activeFilters.push({
                key: 'label',
                label: 'Label',
                value: this.filters.label.trim()
            });
        }

        // Valeur en stock filter
        if (this.filters.valeur && this.filters.valeur !== '') {
            activeFilters.push({
                key: 'valeur',
                label: 'Valeur',
                value: `${this.filters.valeurOperator} ${this.filters.valeur}`
            });
        }

        // Prix d'achat filter
        if (this.filters.prixAchat && this.filters.prixAchat !== '') {
            activeFilters.push({
                key: 'prixAchat',
                label: 'Prix d\'achat',
                value: `${this.filters.prixAchatOperator} ${this.filters.prixAchat}`
            });
        }

        // Prix de vente filter
        if (this.filters.prixVente && this.filters.prixVente !== '') {
            activeFilters.push({
                key: 'prixVente',
                label: 'Prix de vente',
                value: `${this.filters.prixVenteOperator} ${this.filters.prixVente}`
            });
        }

        // Stock filter
        if (this.filters.stock && this.filters.stock !== '') {
            activeFilters.push({
                key: 'stock',
                label: 'Stock',
                value: this.filters.stock
            });
        }

        return activeFilters;
    }

    trackByFilterKey(index: number, filter: {key: string, label: string, value: any}): string {
        return filter.key;
    }

    removeFilter(filterKey: string): void {
        if (filterKey === 'label') {
            this.filters.label = '';
        } else if (filterKey === 'valeur') {
            this.filters.valeur = '';
            this.filters.valeurOperator = '=';
        } else if (filterKey === 'prixAchat') {
            this.filters.prixAchat = '';
            this.filters.prixAchatOperator = '=';
        } else if (filterKey === 'prixVente') {
            this.filters.prixVente = '';
            this.filters.prixVenteOperator = '=';
        } else if (filterKey === 'stock') {
            this.filters.stock = '';
        }
        
        this.updateFilterSummary();
        this.updateFilteredData();
    }


    hasActiveFilters(): boolean {
        return Object.values(this.filters).some((value: any) =>
            value !== '' && value !== null && value !== undefined
        ) || !!(this.searchTerm && this.searchTerm.trim() !== '');
    }
    /**
     * GET /api/stock/entrepot/:entrepot_id — toutes les pages puis mapping des lignes.
     */
    loadProductsForWarehouse(_page: number = 1, pageSize: number = 500): void {
        if (!this.warehouseId) {
            console.warn('warehouseId is missing');
            this.isLoading = false;
            this.allData = [];
            this.items = [];
            this.filteredData = [];
            this.totalItems = 0;
            this.totalPages = 1;
            this.updatePagination();
            return;
        }

        this.isLoading = true;
        const accumulated: any[] = [];
        let apiPage = 1;

        const fetchPage = (): void => {
            this.stockService.getStockByEntrepot(this.warehouseId, apiPage, pageSize).subscribe({
                next: (res) => {
                    const stocks = res.data?.stocks ?? [];
                    accumulated.push(...stocks);
                    const lastPage =
                        res.data?.pagination?.last_page ??
                        res.data?.pagination?.total_pages ??
                        res.data?.pagination?.lastPage;
                    const hasMore =
                        stocks.length >= pageSize &&
                        (lastPage == null || apiPage < Number(lastPage));

                    if (hasMore && stocks.length > 0) {
                        apiPage++;
                        fetchPage();
                    } else {
                        const rows = accumulated.map((s) => this.mapStockLineToEtatRow(s));
                        this.processEtatStockRows(rows);
                    }
                },
                error: () => {
                    this.toastr.error('Erreur lors du chargement de l’état de stock', 'Stock');
                    this.isLoading = false;
                    this.allData = [];
                    this.items = [];
                    this.filteredData = [];
                    this.totalItems = 0;
                    this.totalPages = 1;
                    this.updatePagination();
                }
            });
        };

        fetchPage();
    }

    /**
     * Aplatit une ligne API stock (souvent `{ quantity, product: { ref_interne, nom, ... } }`).
     */
    private mapStockLineToEtatRow(stock: any): EtatStockRow {
        const p = stock?.product ?? {};
        const qty = Number(stock?.quantity ?? 0);
        const prixAchat = Number(
            p.prix_unitaires ?? p.prix_achat ?? stock.prix_unitaires ?? stock.prix_achat ?? 0
        );
        const prixVenteRaw = p.prixVente ?? p.prix_vente ?? stock.prixVente ?? stock.prix_vente ?? null;
        const prixVente =
            prixVenteRaw != null && prixVenteRaw !== '' ? Number(prixVenteRaw) : null;
        const productId = Number(
            p.product_id ?? p.id ?? stock.product_id ?? stock.product?.product_id ?? 0
        );
        const ref = String(p.ref_interne ?? stock.ref_interne ?? '');
        const nom = String(p.nom ?? stock.nom ?? '');
        const valeur = qty * (Number.isFinite(prixAchat) ? prixAchat : 0);

        return {
            id: productId,
            ref_interne: ref,
            nom,
            prix_unitaires: prixAchat,
            prixVente: Number.isFinite(prixVente as number) ? (prixVente as number) : null,
            quantity: qty,
            valeur_en_stock: valeur,
            stock: qty
        };
    }

    private processEtatStockRows(rows: EtatStockRow[]): void {
        this.allData = [...rows];

        if (rows.length === 0) {
            this.items = [];
            this.filteredData = [];
            this.totalItems = 0;
            this.totalPages = 1;
        } else {
            this.totalItems = rows.length;
            if (this.hasActiveFilters()) {
                this.updateFilteredData();
            } else {
                this.filteredData = [...rows];
            }
        }

        this.isLoading = false;
        this.updatePagination();
    }

    updateFilteredData() {
        // Start with warehouse-filtered data
        let result = [...this.allData];

        // Apply label filter (using 'nom' instead of 'label' based on your table data)
        if (this.filters.label && this.filters.label.trim() !== '') {
            const labelFilter = this.filters.label.toLowerCase().trim();
            result = result.filter(item =>
                item.nom?.toLowerCase().includes(labelFilter)
            );
        }

        // Apply valeur filter - Note: You don't have 'valeur' in your table data
        if (this.filters.valeur && this.filters.valeur !== '') {
            const valeurNum = Number(this.filters.valeur);
            const operator = this.filters.valeurOperator;

            result = result.filter(item => {
                // You need to replace 'item.valeur' with the actual property name from your data
                // Based on your table, it seems you don't have this property
                const itemValeur = Number(item.valeur_en_stock) || 0;

                switch(operator) {
                    case '=':
                        return itemValeur === valeurNum;
                    case '>':
                        return itemValeur > valeurNum;
                    case '<':
                        return itemValeur < valeurNum;
                    default:
                        return true;
                }
            });
        }

        // Apply prixAchat filter
        if (this.filters.prixAchat && this.filters.prixAchat !== '') {
            const prixAchatNum = Number(this.filters.prixAchat);
            const operator = this.filters.prixAchatOperator;

            result = result.filter(item => {
                const itemPrixAchat = Number(item.prix_unitaires) || 0;

                switch(operator) {
                    case '=':
                        return itemPrixAchat === prixAchatNum;
                    case '>':
                        return itemPrixAchat > prixAchatNum;
                    case '<':
                        return itemPrixAchat < prixAchatNum;
                    default:
                        return true;
                }
            });
        }

        // Apply prixVente filter
        if (this.filters.prixVente && this.filters.prixVente !== '') {
            const prixVenteNum = Number(this.filters.prixVente);
            const operator = this.filters.prixVenteOperator;

            result = result.filter(item => {
                const itemPrixVente = Number(item.prixVente) || 0;

                switch(operator) {
                    case '=':
                        return itemPrixVente === prixVenteNum;
                    case '>':
                        return itemPrixVente > prixVenteNum;
                    case '<':
                        return itemPrixVente < prixVenteNum;
                    default:
                        return true;
                }
            });
        }

        // Apply stock filter (quantité)
        if (this.filters.stock && this.filters.stock !== '') {
            const stockNum = Number(this.filters.stock);
            result = result.filter((item) => {
                const itemStock = Number((item as EtatStockRow).quantity ?? (item as EtatStockRow).stock) || 0;
                return itemStock === stockNum;
            });
        }

        // Apply search term
        if (this.searchTerm && this.searchTerm.trim() !== '') {
            const searchLower = this.searchTerm.toLowerCase().trim();
            result = result.filter((item) => {
                const row = item as EtatStockRow;
                return (
                    row.nom?.toLowerCase().includes(searchLower) ||
                    row.ref_interne?.toLowerCase().includes(searchLower) ||
                    (row.prix_unitaires?.toString() || '').includes(searchLower) ||
                    (row.prixVente?.toString() || '').includes(searchLower) ||
                    (row.quantity?.toString() || '').includes(searchLower)
                );
            });
        }

        this.filteredData = result;
        this.totalItems = result.length;
        this.updatePagination();
    }
    changePage(page: number) {
        this.currentPage = page;
        this.updatePagination();
    }

    trackByEtatRow(_index: number, row: EtatStockRow): string {
        return `${row.id}-${row.ref_interne}-${row.quantity}`;
    }

    detail(productId: number) {
        if (productId == null || productId <= 0) {
            this.toastr.warning('Produit non lié à l’ERP.', 'Détail');
            return;
        }
        this.ngZone.run(() => {
            this.router.navigate(['/produits-services/detail-produit', productId]);
        });
    }

}
